import { render } from "./ButtonLike.vue?vue&type=template&id=5361379c&scoped=true"
import script from "./ButtonLike.vue?vue&type=script&lang=js"
export * from "./ButtonLike.vue?vue&type=script&lang=js"

import "./ButtonLike.vue?vue&type=style&index=0&id=5361379c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5361379c"]])

export default __exports__